import React from 'react'
import { Container, Row } from 'reactstrap';
import { Modal, ModalHeader,  Button,ModalBody } from "reactstrap";
import  { useState,useEffect } from "react";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../../../Components/Common/Breadcrumb";

// Components
import CardUser from './CardUser';
import Settings from './Settings';

const DashboardBlog: React.FC = () => {

  document.title = "Dashboard | BizServe";

  const [modal_two_fact, setmodal_two_fact] = useState(false);
  const newtoggle = () => setmodal_two_fact(!modal_two_fact);
  const c_user_role = localStorage.getItem("userole_")
  const pop_status = localStorage.getItem("two_fact_shown")
  const check_enable_two_fact = localStorage.getItem("enable_two_fact")

  useEffect(() => {
    if((c_user_role === "exp" || c_user_role === "adm") &&
    check_enable_two_fact !== "true" &&
    !pop_status){
    setmodal_two_fact(true);
    localStorage.setItem("two_fact_shown","true");
    }
  },[c_user_role,check_enable_two_fact,pop_status])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboards" breadcrumbItem="Expert Dashboard" />

          <div>
          <Modal isOpen={modal_two_fact} centered className="rounded-4">
            <ModalHeader toggle={newtoggle}>
              <div className="modal-title mt-0 font-size-16 text-dark">
                Security Alert
              </div>
            </ModalHeader>
            <ModalBody className="text-center">
              <h4 className="mb-3 text-danger">Two-Factor Authentication Disabled</h4>
              
              <p className="text-muted">
                {c_user_role === "adm"
                ? "To keep your account secure, please enable Two-Factor Authentication."
                : "For better account security, please enable Two-Factor Authentication."}    
              </p>
              <Link to= { c_user_role === "adm" ? "/aprofile" : "/eprofile"}>
              <Button color="primary">Enable Now</Button>
              </Link>
            </ModalBody>
          </Modal>
          </div>

          <Row>
            <CardUser dataColors='["--bs-primary", "--bs-warning"]' />
            <Settings />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DashboardBlog;
